import React, { useState, useEffect } from 'react';
import { Badge, Button, Form, InputGroup } from 'react-bootstrap';
import './StaffManagement.css';
import { oneKlicks } from '../../SDK/oneclick';
import MapSearchModal from '../Components/MapSearchModal';
import { FaMapMarkerAlt } from 'react-icons/fa';
import ImageShow from '../../Uitiles/ImageShow';

const StaffManagement = () => {
    const [staff, setStaff] = useState([]);
    const [roles, setRoles] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingStaff, setEditingStaff] = useState(null);
    const [isChecking, setIsChecking] = useState(false);
    const [checkResult, setCheckResult] = useState(null);
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        permissions: [],
        role: [],
        location: null,
        address: '',
        status: 1
    });
    const [searchTerm, setSearchTerm] = useState('');
    const [isMapModalVisible, setIsMapModalVisible] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    // Sample permissions
    const permissions = [
        { label: 'View Dashboard', value: 'view_dashboard' },
        { label: 'Manage Appointments', value: 'manage_appointments' },
        { label: 'Manage Doctors', value: 'manage_doctors' },
        { label: 'Manage Staff', value: 'manage_staff' },
        { label: 'Manage Patients', value: 'manage_patients' },
        { label: 'Manage Settings', value: 'manage_settings' },
        { label: 'Manage Pharmacies', value: 'manage_pharmacies' },
        { label: 'Manage Orders', value: 'manage_orders' },
        { label: 'Manage Invoices', value: 'manage_invoices' },
        { label: 'Manage Payments', value: 'manage_payments' },
        { label: 'Manage Reports', value: 'manage_reports' },
        { label: 'Manage Settings', value: 'manage_settings' },
        { label: 'Manage Users', value: 'manage_users' },
        { label: 'Manage Roles', value: 'manage_roles' },
        { label: 'Manage Permissions', value: 'manage_permissions' },
        { label: 'Manage Notifications', value: 'manage_notifications' },
        { label: 'Manage Logs', value: 'manage_logs' },
        { label: 'Manage System', value: 'manage_system' },
        { label: 'Manage Reports', value: 'manage_reports' },
        { label: 'Manage Settings', value: 'manage_settings' },
        { label: 'Manage Users', value: 'manage_users' },
        { label: 'Manage Roles', value: 'manage_roles' },
        { label: 'View Profile', value: 'view_profile' },
        { label: 'View Inbox', value: 'view_inbox' },
        { label: 'Manage Profile', value: 'manage_profile' },
        { label: 'View Saved Items', value: 'view_saved_items' },
        { label: 'Manage Hospitals', value: 'manage_hospitals' },           
    ];

    useEffect(() => {
        fetchStaff();
        fetchRoles();
    }, []);




    const fetchStaff = async () => {
        try {
            const tableSchema = '';
            const tableName = 'users';
            const conditions = {
                user_type: 'staff'
            };
            const orderBy = "id DESC";
            const search = '';
            const pagination = {};
            const margedata = [
                {
                    target_table: 'roles',
                    target_column: 'id',
                    target_value: 'role',
                    target_label: 'roles'
                }
            ];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log('fetchStaff response :', response);
            if (response.success) {
                setStaff(response.data); 
            } else {
                console.error('Error fetching staff:', response.message);
            }
        } catch (error) {
            console.error('Error fetching staff:', error);
        }
    };

    const fetchRoles = async () => {
        try {
            const tableSchema = '';
            const tableName = 'roles';
            const conditions = {};
            const orderBy = 'id DESC';
            const search = {};
            const pagination = {};
            const margedata = {};
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            
            if (response.success && response.data) {
                // Parse permissions JSON string for each role
                const parsedRoles = response.data.map(role => {
                    let parsedPermissions = [];
                    try {
                        if (typeof role.permissions === 'string') {
                            parsedPermissions = JSON.parse(role.permissions);
                        } else if (Array.isArray(role.permissions)) {
                            parsedPermissions = role.permissions;
                        }
                    } catch (parseError) {
                        console.error('Error parsing permissions for role:', role.role_name, parseError);
                        parsedPermissions = [];
                    }
                    
                    return {
                        ...role,
                        permissions: parsedPermissions
                    };
                });
                
                setRoles(parsedRoles);
                console.log("parsedRoles :", parsedRoles);
            } else {
                console.error('Error fetching roles:', response.message);
            }
        } catch (error) {
            console.error('Error fetching roles:', error);
        }
    };

    const handleAdd = () => {
        setEditingStaff(null);
        setCheckResult(null);
        setFormData({
            first_name: '',
            last_name: '',
            email: '',
            role: [], // array of role ids
            location: null,
            address: '',
            status: 1
        });
        setIsModalVisible(true);
    };

    const handleEdit = (record) => {
        setEditingStaff(record);
        setCheckResult(null);
        console.log("record location :", record.location);
        
        // Parse permissions if it's a string
        let parsedPermissions = [];
        if (typeof record.permissions === 'string') {
            try {
                parsedPermissions = JSON.parse(record.permissions);
            } catch (e) {
                parsedPermissions = [];
            }
        } else if (Array.isArray(record.permissions)) {
            parsedPermissions = record.permissions;
        }
        
        setFormData({
            ...record,
            permissions: parsedPermissions,
            address: record.address || '',
            status: record.status || 1
        });
        setIsModalVisible(true);
    };

    const handleDelete = (id) => {
        setStaff(staff.filter(item => item.id !== id));
        alert('Staff member deleted successfully');
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handlePermissionChange = (e) => {
        const options = e.target.options;
        const selectedPermissions = [];
        for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
                selectedPermissions.push(options[i].value);
            }
        }
        setFormData(prev => ({
            ...prev,
            permissions: selectedPermissions
        }));
    };

    const handleRoleChange = (e) => {
        const options = e.target.options;
        const selectedRoles = [];
        for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
                selectedRoles.push(options[i].value);
            }
        }
        setFormData(prev => ({
            ...prev,
            role: selectedRoles.map(role => parseInt(role))
        }));
    };

    // Check staff data validation
    const handleCheck = async () => {
        setIsChecking(true);
        setCheckResult(null);
        
        try {
            // Simulate API check - replace with actual validation logic
            await new Promise(resolve => setTimeout(resolve, 1000));
            
            const errors = [];
            
            // Email validation
            if (!formData.email) {
                errors.push('Email is required');
            } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
                errors.push('Invalid email format');
            }
            
            // Check if email already exists
            const emailExists = staff.some(member => 
                member.email === formData.email && 
                (!editingStaff || member.id !== editingStaff.id)
            );
            if (emailExists) {
                errors.push('Email already exists');
            }
            
            // Name validation
            if (!formData.first_name.trim()) {
                errors.push('First name is required');
            }
            if (!formData.last_name.trim()) {
                errors.push('Last name is required');
            }
            
            // Permission validation
            if (!formData.permissions || formData.permissions.length === 0) {
                errors.push('At least one permission is required');
            }
            
            setCheckResult({
                isValid: errors.length === 0,
                errors: errors,
                timestamp: new Date().toLocaleString()
            });
            
        } catch (error) {
            setCheckResult({
                isValid: false,
                errors: ['Check failed: ' + error.message],
                timestamp: new Date().toLocaleString()
            });
        } finally {
            setIsChecking(false);
        }
    };

    const handleLocationSelect = (locationData) => {
        setFormData(prev => ({
            ...prev,
            location: locationData.location,
            address: locationData.address
        }));
    };

    const handleMapSearch = () => {
        setIsMapModalVisible(true);
    };

    const handleSubmit = async (e) => {
        try {
            setSubmitLoading(true);
            e.preventDefault();
            if (editingStaff) {
                setStaff(staff.map(item =>
                    item.id === editingStaff.id ? { ...formData, id: item.id } : item
                ));
                const tableSchema = '';
                const tableName = 'users';
                const conditions = {
                    id: editingStaff.id
                };
                const data = {
                    first_name: formData.first_name,
                    last_name: formData.last_name,
                    email: formData.email,
                    user_type: 'staff',
                    role: Array.isArray(formData.role) ? formData.role.map(role => parseInt(role)) : null,
                    location: formData.location ? JSON.stringify(formData.location) : null,
                    address: formData.address,
                    status: formData.status
                };
                const response = await oneKlicks.update(tableSchema, tableName, data, conditions);
                if (response.success) {
                    alert('Staff member updated successfully');
                } else {
                    console.error('Error updating staff:', response.message);
                }
            } else {
                const newStaff = {
                    ...formData,
                    id: Date.now(),
                };
                const tableSchema = '';
                const tableName = 'users';
                const conditions = {
                    email: formData.email
                };
                const data = {
                    first_name: formData.first_name,
                    last_name: formData.last_name,
                    email: formData.email,
                    user_type: 'staff',
                    role: Array.isArray(formData.role) ? formData.role.map(role => parseInt(role)) : null,
                    location: formData.location ? JSON.stringify(formData.location) : null,
                    address: formData.address,
                    status: formData.status
                };
                const response = await oneKlicks.create(tableSchema, tableName, data, conditions);

                console.log('create staff response :', response);
                if (response.success) {
                    setStaff([...staff, newStaff]);
                    alert('Staff member added successfully');
                    setSubmitLoading(false);
                    setIsModalVisible(false);
                } else {
                    setSubmitLoading(false);
                    alert('Error adding staff: ' + response.message);
                    console.error('Error adding staff:', response.message);
                }
            }
            
        } catch (error) {
            console.error('Error adding staff:', error);
        } finally {
            fetchStaff();
        }
    };

    return (
        <div className="dc-haslayout dc-dbsectionspace">
            <div className="container-fluid py-3">
                <div className="card mb-5">
                    <div className="card-body">
                        <div className="align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center gap-2  mb-2">
                                <h5 className="mb-0 font-weight-bold mr-3">Staff Management</h5>
                                {/* <Badge bg="info">{submitLoading ? 'Submitting...' : '..'}</Badge> */}
                            </div>
                            <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                                <InputGroup className="p-0" style={{ maxWidth: 400, flex: "1 1 auto" }}>
                                    <Form.Control
                                        placeholder="Search..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </InputGroup>
                                <Button variant="primary" onClick={handleAdd}>+ Add Staff</Button>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className="card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-hover table-striped" >
                                    <thead>
                                            <tr>
                                            <th>ID</th>
                                            <th>Image</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Location</th>
                                            <th>Role</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {staff.map((member, index) => (
                                        <tr key={member.id} className={member.status} style={{backgroundColor: member.status === 1 ? '' : member.status === 0 ? '#f8d7da' : '#f8d7da'}}>
                                            <td data-label="ID">{index + 1}</td>
                                            <td data-label="Image">
                                                <ImageShow url={member.profile_photo_url} width={50} height={50} style={{ objectFit: 'cover', borderRadius: '50%', width: '50px', height: '50px' }} /></td>
                                            <td data-label="Name" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',  }}>{member.first_name} {member.last_name}</td>
                                            <td data-label="Email" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',  }}>{member.email}</td>
                                            <td data-label="Location" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',  }}>
                                                {member.address ? (
                                                    <div className="location-cell">
                                                        <div className="location-address">{member.address}</div>
                                                        {member.location && (
                                                            <div className="location-coords">
                                                                {(() => {
                                                                    try {
                                                                        const loc = typeof member.location === 'string' 
                                                                            ? JSON.parse(member.location) 
                                                                            : member.location;
                                                                        return `${loc.lat.toFixed(4)}, ${loc.lng.toFixed(4)}`;
                                                                    } catch (e) {
                                                                        return 'Invalid coordinates';
                                                                    }
                                                                })()}
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <span className="no-location">No location set</span>
                                                )}
                                            </td>
                                            <td data-label="Role" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',  }}>
                                                
                                                {member.roles?.length > 0 && member.roles[0].role_name ? member.roles[0].role_name.charAt(0).toUpperCase() + member.roles[0].role_name.slice(1) : 'No Role'}    
                                            </td>
                                            <td data-label="Actions">
                                                <div className="d-flex gap-2" style={{ flexDirection: 'row', justifyContent: 'flex-end', gap: '10px' }}>
                                                    <Button variant="primary" onClick={() => handleEdit(member)}>Edit</Button>
                                                    <Button variant="danger" onClick={() => handleDelete(member.id)}>Delete</Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
            </div>

            {isModalVisible && (
                <div className="modal-overlay">
                    <div className="modal-content" style={{width: '500px', display: 'block !important'}}>
                        <div className="modal-header">
                            <h3>{editingStaff ? 'Edit Staff Member' : 'Add Staff Member'}</h3>
                            <button
                                className="close-button"
                                onClick={() => {
                                    setIsModalVisible(false);
                                    setFormData({
                                        first_name: '',
                                        last_name: '',
                                        email: '',
                                        permissions: [],
                                        role: [],
                                        location: null,
                                        address: '',
                                        status: '1'
                                    });
                                    setEditingStaff(null);
                                    setCheckResult(null);
                                    setSubmitLoading(false);
                                }}
                                aria-label="Close"
                            >
                                ×
                            </button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="d-flex flex-row gap-2" style={{gap: '10px'}}>
                                <div className="form-group">
                                    <label htmlFor="name">First Name:</label>
                                        <input
                                            type="text"
                                            id="first_name"
                                            name="first_name"
                                            value={formData.first_name}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="name">Last Name:</label>
                                        <input
                                            type="text"
                                            id="last_name"
                                            name="last_name"
                                            value={formData.last_name}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                            </div>
                                
                            

                            <div className="form-group">
                                <label htmlFor="email">Email:</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>


                            <div className="form-group">
                                <label htmlFor="permissions">Select Role:</label>
                                <select
                                    id="role"
                                    name="role"
                                    multiple
                                    value={editingStaff ? (editingStaff?.roles?.length > 0 ? editingStaff?.roles[0]?.id.toString() : '') : (Array.isArray(formData.role) ? formData.role.map(role => parseInt(role)) : [])}
                                    onChange={handleRoleChange}
                                >
                                    {Array.isArray(roles) && roles.length > 0 ? (
                                        roles.map(role => (
                                            <option key={role.id} value={role.id.toString()}>
                                                {role.role_name}
                                            </option>
                                        ))
                                    ) : (
                                        <option value="">No roles found</option>
                                    )}
                                </select>
                            </div>

                            {/* Check Button and Result */}
                            <div className="form-group">
                                <button
                                    type="button"
                                    className="check-button"
                                    onClick={handleCheck}
                                    disabled={isChecking}
                                    style={{
                                        backgroundColor: '#007bff',
                                        color: 'white',
                                        border: 'none',
                                        padding: '10px 20px',
                                        borderRadius: '4px',
                                        cursor: isChecking ? 'not-allowed' : 'pointer',
                                        opacity: isChecking ? 0.6 : 1,
                                        marginBottom: '10px'
                                    }}
                                >
                                    {isChecking ? 'Checking...' : 'Check Staff Data'}
                                </button>
                                
                                {checkResult && (
                                    <div 
                                        style={{
                                            padding: '10px',
                                            borderRadius: '4px',
                                            backgroundColor: checkResult.isValid ? '#d4edda' : '#f8d7da',
                                            border: `1px solid ${checkResult.isValid ? '#c3e6cb' : '#f5c6cb'}`,
                                            color: checkResult.isValid ? '#155724' : '#721c24',
                                            marginBottom: '10px'
                                        }}
                                    >
                                        <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                                            {checkResult.isValid ? '✓ Validation Passed' : '✗ Validation Failed'}
                                        </div>
                                        {checkResult.errors && checkResult.errors.length > 0 && (
                                            <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                                {checkResult.errors.map((error, index) => (
                                                    <li key={index}>{error}</li>
                                                ))}
                                            </ul>
                                        )}
                                        <small style={{ opacity: 0.7 }}>
                                            Checked at: {checkResult.timestamp}
                                        </small>
                                    </div>
                                )}
                            </div>

                            <div className="form-group">
                                <label htmlFor="location">Location:</label>
                                <div className="location-input-container">
                                    <input
                                        type="text"
                                        id="address"
                                        name="address"
                                        value={formData.address}
                                        placeholder="Search for location..."
                                        readOnly
                                        className="location-input"
                                    />
                                    <button
                                        type="button"
                                        className="map-search-button"
                                        onClick={handleMapSearch}
                                    >
                                        <FaMapMarkerAlt />
                                        Search on Map
                                    </button>
                                </div>
                                {formData.location && (
                                    <div className="location-info">
                                        <small>
                                            Coordinates: {formData.location.lat.toFixed(6)}, {formData.location.lng.toFixed(6)}
                                        </small>
                                    </div>
                                )}
                            </div>

                            {editingStaff && (
                                <div className="form-group">
                                    <label htmlFor="password">Status:</label>
                                    <select id="status" name="status" value={formData.status} onChange={handleInputChange} required>
                                        <option value="1">Active</option>
                                        <option value="0">Closed</option>
                                        <option value="2">Inactive</option>
                                    </select>
                                </div>
                            )}

                            <div className="modal-footer" style={{padding: '15px 0px'}}>
                                <div className="button-group">
                                    <button type="submit" className="submit-button" disabled={submitLoading}>
                                        {submitLoading ? 'Submitting...' : (editingStaff ? 'Update' : 'Add')}
                                    </button>
                                    <button
                                        type="button"
                                        className="cancel-button"
                                        onClick={() => {
                                            setIsModalVisible(false);
                                            setFormData({
                                                first_name: '',
                                                last_name: '',
                                                email: '',
                                                permissions: [],
                                                role: [],
                                                location: null,
                                                address: '',
                                                status: 'active'
                                            });
                                            setSubmitLoading(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            <MapSearchModal
                isVisible={isMapModalVisible}
                onClose={() => setIsMapModalVisible(false)}
                onLocationSelect={handleLocationSelect}
                initialLocation={formData.location}
            />
        </div>
        // <div className="staff-management">
        //     <div className="row" style={{display: 'flex', justifyContent: 'space-between', marginLeft: '0px', marginRight: '-1px', padding: '31px 0px'}}>
        //         <h2>Staff Management</h2>
        //         <button className="add-button" onClick={handleAdd}>
        //             Add Staff
        //         </button>
        //     </div>

        //     <div className="staff-table-container">
        //         <table className="staff-table">
        //             <thead>
        //                 <tr>
        //                     <th>S.No</th>
        //                     <th>Name</th>
        //                     <th>Email</th>
        //                     <th>Role</th>
        //                     <th>Location</th>
        //                     <th>Permissions</th>
        //                     <th>Actions</th>
        //                 </tr>
        //             </thead>
        //             <tbody>
        //                 {staff.map((member, index) => (
        //                     <tr key={member.id}>
        //                         <td>{index + 1}</td>
        //                         <td>{member.first_name} {member.last_name}</td>
        //                         <td>{member.email}</td>
        //                         <td>{member.role}</td>
        //                         <td>
        //                             {member.address ? (
        //                                 <div className="location-cell">
        //                                     <div className="location-address">{member.address}</div>
        //                                     {member.location && (
        //                                         <div className="location-coords">
        //                                             {(() => {
        //                                                 try {
        //                                                     const loc = typeof member.location === 'string' 
        //                                                         ? JSON.parse(member.location) 
        //                                                         : member.location;
        //                                                     return `${loc.lat.toFixed(4)}, ${loc.lng.toFixed(4)}`;
        //                                                 } catch (e) {
        //                                                     return 'Invalid coordinates';
        //                                                 }
        //                                             })()}
        //                                         </div>
        //                                     )}
        //                                 </div>
        //                             ) : (
        //                                 <span className="no-location">No location set</span>
        //                             )}
        //                         </td>
        //                         <td>
        //                             {(() => {
        //                                 let perms = member.permissions;
        //                                 // If permissions is a string (e.g., '["view_dashboard","manage_doctors"]'), parse it
        //                                 if (typeof perms === 'string') {
        //                                     try {
        //                                         perms = JSON.parse(perms);
        //                                     } catch (e) {
        //                                         perms = [];
        //                                     }
        //                                 }
        //                                 return perms && perms.length
        //                                     ? perms.join(', ')
        //                                     : 'No Permissions';
        //                             })()}
        //                         </td>
        //                         <td>
        //                             <button className="edit-button" onClick={() => handleEdit(member)}>
        //                                 Edit
        //                             </button>
        //                             <button className="delete-button" onClick={() => handleDelete(member.id)}>
        //                                 Delete
        //                             </button>
        //                         </td>
        //                     </tr>
        //                 ))}
        //             </tbody>
        //         </table>
        //     </div>

        

        //     <MapSearchModal
        //         isVisible={isMapModalVisible}
        //         onClose={() => setIsMapModalVisible(false)}
        //         onLocationSelect={handleLocationSelect}
        //         initialLocation={formData.location}
        //     />
        // </div>
    );
};

export default StaffManagement; 
